import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { Tabs } from 'antd';
import columns from '../../../../columns/dashboardAccount';
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton';

const AccountTabs = ({ data }) => {
    const [activeTab, setActiveTab] = useState(1);
    const [filteredData, setFilteredData] = useState([]);

    const items = [
        { key: 1, label: 'Live Account' },
        { key: 2, label: 'Demo Account' },
    ];

    useEffect(() => {
        let accounts = [];

        if (activeTab === 1) {
            accounts = data?.filter((account) => account?.isLive);
        } else if (activeTab === 2) {
            accounts = data?.filter((account) => account?.isDemo);
        }

        setFilteredData(accounts?.map((item) => {
            return {
                ...item,
                balance: `$ ${item?.balance}`,
                createdAt: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY LT') : null,
            }
        }));
    }, [activeTab, data]);

    return (
        <div className="border-2 border-light rounded-[10px] h-full">
            <Tabs defaultActiveKey="1" items={items} onChange={(tab) => setActiveTab(tab)} className="w-full custom-tabs" centered />

            <div className="p-5 pt-3">
                <TableWithSkeleton columns={columns} data={filteredData} />
            </div>
        </div>
    );
}

export default AccountTabs
